import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WorkLocationRoutingModule } from './work-location-routing.module';
import { SharedModule } from '../../../../shared/shared.module';
import { WorkLocationDetailsComponent } from './work-location-details/work-location-details.component';
import { WorkLocationCreateComponent } from './work-location-create/work-location-create.component';
import { WorkLocationEditComponent } from './work-location-edit/work-location-edit.component';
import { WorkLocationFormContentComponent } from './shared/work-location-form-content/work-location-form-content.component';

@NgModule({
  declarations: [
    WorkLocationDetailsComponent,
    WorkLocationCreateComponent,
    WorkLocationEditComponent,
    WorkLocationFormContentComponent,
  ],
  imports: [CommonModule, SharedModule, WorkLocationRoutingModule],
})
export class WorkLocationModule {}
